export default [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/auth/Login.vue"),
    meta: {
      layout: "full",
    },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/auth/Register.vue"),
    meta: {
      layout: "full",
    },
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: () => import("@/views/auth/ResetPassword.vue"),
    meta: {
      layout: "full",
    },
  },
  {
    path: "/welcome",
    name: "welcome",
    component: () => import("@/views/auth/Welcome.vue"),
    meta: {
      layout: "full",
    },
  },
  {
    path: "/goodbye",
    name: "goodbye",
    component: () => import("@/views/auth/Goodbye.vue"),
    meta: {
      layout: "full",
    },
  },
];
